<template>
    <div>
         <div id="figures" v-if="location == 1">
            <img src="/assets/img/figures-g-green-hor.svg" class="figure girl-green" />
            <img src="/assets/img/figures-g-yellow-hor.svg" class="figure girl-yellow" />
            <img src="/assets/img/figures-g-b-hor.svg" class="figure girl-boy" />
            <img src="/assets/img/figures-b-g-hor.svg" class="figure boy-girl" />
        </div>
        <div id="figures" v-if="location == 2">
            <img src="/assets/img/figures-g-green-kus.svg" class="figure girl-green" />
            <img src="/assets/img/figures-g-yellow-kus.svg" class="figure girl-yellow" />
            <img src="/assets/img/figures-g-b-kus.svg" class="figure girl-boy" />
            <img src="/assets/img/figures-b-g-kus.svg" class="figure boy-girl" />
        </div>
        <form class="contact-form" v-bind:class="[showerrors ? 'showerrors' : '', ]" v-if="!formHasBeenSended">
            <section class="offer page-wrapper-inner" >
                <div class="block">
                    <div>
                        <label class="subtitle horgen" v-if="location == 1">Horgen</label>
                        <label class="subtitle kuesnacht" v-if="location == 2">Küsnacht</label>
                        <h3 v-if="type=='school' && appmode == 'offer'" >{{ trans.application.register_title[lang] }} {{ sector.name }}</h3>
                        <h3 v-if="type=='holiday_intern'" >{{ trans.application.register_title[lang] }} {{ trans.global.holidaycare[lang] }}</h3>
                        <h3 v-if="type=='holiday_extern'" >{{ trans.application.register_title[lang] }} {{ trans.global.holidaycare[lang] }}</h3>

                        <div v-if="type=='school'">

                            <p v-if="appmode == 'offer'" v-html="trans.application.introschool[lang]"></p>
                             <br>
                             <h4 v-if="appmode == 'change'">
                                <label v-html="trans.application.introschool_change[lang]"></label>
                                <label v-if="location == 1">Horgen.</label>
                                <label v-if="location == 2">Küsnacht.</label>
                             </h4>

                            <div class="downloadbox">
                                <h4>{{ trans.application.zusammenfassung[lang] }}</h4>
                                <a target="_blank" :href="'/download/' + location + '/' + sector.id + (lang == 'en' ? '/en':'/de')" class="pdf">
                                    {{ trans.application.downloadpdf[lang] }}
                                </a>
                            </div>

                        </div>

                    </div>
                    <ul class="accordion-form">
                        <li v-bind:class="[{ 'js-accordion formsection': section.type != 'fix' }]"  v-for="(section,index) in formdata"  :key="index">
                            <label @click="section.open = section.open!=true" v-if="section.type != 'fix'">
                                <span v-bind:class="[section.isvalid && section.hascontent ? 'checkbox checked' : 'checkbox',section.haserror ? 'haserror' : '']"></span>
                                {{section.title}}
                            </label>
                            <div v-bind:class="[{ 'js-accordion-content accordion__content': section.type != 'fix'  }, section.haserror ? 'haserror' : '']" >
                                <div class="form-group" v-for="(field,idx) in section.fields" :key="idx" v-bind:class="[{'hasError':!field.isvalid},field.class]">
                                    <input-text-component v-on:update="validateGroup(index)" v-if="field.type == 'text' && checkCondition(field.condition)" :repeats="field.repeats" :remarks="field.remarks" :titlebefore="field.titlebefore" :name="field.name" :placeholder="field.placeholder" :label="field.label" v-model="field.value"  />

                                    <input-date-component :trans="trans" :islunch="islunch" :lang="lang" v-on:update="validateGroup(index)" :mode="field.mode" v-if="field.type == 'date' && checkCondition(field.condition)" :label="field.label" :titlebefore="field.titlebefore" :remarks="field.remarks" v-model="field.value" />

                                    <input-date-component :trans="trans" :islunch="islunch" :lang="lang" v-on:update="validateGroup(index)" :mode="field.mode" v-if="field.type == 'datemonth' && checkCondition(field.condition)" :hideday="true" :label="field.label" :titlebefore="field.titlebefore" :remarks="field.remarks" v-model="field.value" />

                                    <input-daterange-component :trans="trans" :lang="lang" v-on:update="validateGroup(index)" :mode="field.mode" v-if="field.type == 'daterange' && checkCondition(field.condition)" :label="field.label" :titlebefore="field.titlebefore" :remarks="field.remarks" v-model="field.value" />

                                    <input-radio-component v-on:update="validateGroup(index)" :currentvalues="field.value" :selection='field.selection' :index="idx" v-if="field.type == 'radio' && checkCondition(field.condition)" :label="field.label" :titlebefore="field.titlebefore" :remarks="field.remarks" v-model="field.value"   />

                                    <input-textarea-component v-on:update="validateGroup(index)"  v-if="field.type == 'textarea' && checkCondition(field.condition)"  :remarks="field.remarks" :titlebefore="field.titlebefore" :name="field.name" :label="field.label"  v-model="field.value"  />

                                    <input-checkbox-component v-on:update="validateGroup(index)"  :currentvalues="field.value" :selection='field.selection' :index="index + '-' +idx" v-if="field.type == 'checkbox' && checkCondition(field.condition)" :label="field.label" :titlebefore="field.titlebefore" :remarks="field.remarks" v-model="field.value" />
                                </div>
                            </div>
                        </li>
                    </ul>

                    <div class="actionbuttons">

                        <div v-if="showerrors === true">

                            <h5 v-if="lang=='de'">Bitte füllen Sie das Formular vollständig aus</h5>
                            <h5 v-if="lang=='en'">Please fill out the form completely.</h5>

                        </div>

                        <div class="lds-ring" v-if="loading"><div></div><div></div><div></div><div></div></div>

                        <button v-if="appmode == 'offer' && !loading" class="btn" @click="send">{{ trans.global.register_btn[lang] }}</button>
                        <button v-if="appmode == 'change' && !loading" class="btn" @click="send">{{ trans.global.send[lang] }}</button>
                    </div>
                </div>
            </section>
        </form>
        <div v-if="formHasBeenSended">
           <section class="answerbox page-wrapper-inner block" >
                <span v-if="lang == 'de'">Das Formular wurde übermittelt. <br>Herzlichen Dank für Ihre Anfrage und Ihr Interesse! </span>
                <span v-if="lang == 'en'">The form has been submitted. <br>Many thanks for your contacting and your interest!  </span>
                <br><br>
                <span v-if="type=='school' && sector.id != 1 && islunch == 0">
                    <span v-if="lang == 'de'">
                        <a v-if="appmode == 'offer' && location == 1" href="/daycare/horgen/1/offer" class="btn" >{{ trans.global.daycare_btn[lang] }}</a>
                        <a v-if="appmode == 'change' && location == 1" href="/daycare/horgen/1/change" class="btn" >{{ trans.global.daycare_btn[lang] }}</a>
                        <a v-if="appmode == 'offer' && location == 2" href="/daycare/kuesnacht/2/offer" class="btn" >{{ trans.global.daycare_btn[lang] }}</a>
                        <a v-if="appmode == 'change' && location == 2" href="/daycare/kuesnacht/2/change" class="btn" >{{ trans.global.daycare_btn[lang] }}</a>
                    </span>
                    <span v-if="lang == 'en'">
                        <a v-if="appmode == 'offer' && location == 1" href="/daycare/horgen/1/offer/en" class="btn" >{{ trans.global.daycare_btn[lang] }}</a>
                        <a v-if="appmode == 'change' && location == 1" href="/daycare/horgen/1/change/en" class="btn" >{{ trans.global.daycare_btn[lang] }}</a>
                        <a v-if="appmode == 'offer' && location == 2" href="/daycare/kuesnacht/2/offer/en" class="btn" >{{ trans.global.daycare_btn[lang] }}</a>
                        <a v-if="appmode == 'change' && location == 2" href="/daycare/kuesnacht/2/change/en" class="btn" >{{ trans.global.daycare_btn[lang] }}</a>
                    </span>
                </span>
            </section>




        </div>


        <formdata1 v-if="type == 'school' && appmode=='offer'" ref="dataset" :trans="trans" :lang="lang"></formdata1>
        <formdata1b v-if="type == 'school' && appmode=='change'" ref="dataset" :trans="trans" :lang="lang"></formdata1b>
        <formdata2 v-if="type == 'holiday_intern'" ref="dataset" :trans="trans" :lang="lang"></formdata2>
        <formdata3 v-if="type == 'holiday_extern'" ref="dataset" :trans="trans" :lang="lang"></formdata3>

    </div>
</template>



<script>

    import formdata1 from './forms/registration_school';
    import formdata1b from './forms/registration_school_change';

    import formdata2 from './forms/registration_holiday_intern';
    import formdata3 from './forms/registration_holiday_extern';

    export default {

        components: {
            formdata1, formdata2,  formdata3,formdata1b
        },

        data: function() {
            return  {
                formcompleted: false,
                formdata: [],
                showerrors: false,
                formHasBeenSended: false,
                loading: false,
                storedData: null
            }
        },
        props: {
            session: {
                type: String,
                required: true
            },
            location: {
                type: Number,
                required: true
            },
             lang: {
                type: String,
                required: true
            },
            trans: {
                type: Object,
                required: true
            },
            sector: {
                type: Object,
                required: true
            },
            type: {
                type: String,
                required: true
            },
            appmode: {
                type: String,
                required: true
            },
            islunch: {
                type: String,
                required: false
            },
        },


        mounted() {
            let app = this;
            app.formdata = this.$refs.dataset.formdata;
            var retrievedObject = JSON.parse(localStorage.getItem('formdata'));

            this.storedData = retrievedObject; // make it visible in console

            if(retrievedObject){
                this.loadStorageData(retrievedObject);
                for (const [key, value] of Object.entries(app.formdata)) {
                    app.validateGroup(key);
                }
            }

        },
        methods: {
            loadStorageData(retrievedObject){
                let app = this;
                for (const [key, value] of Object.entries(retrievedObject)) {
                    for (let i = 0; i < value.fields.length; i++) {


                        for (const [kk, vv] of Object.entries(app.formdata)) {
                            for (let z = 0; z < vv.fields.length; z++) {
                                if(vv.fields[z].id == value.fields[i].id)
                                {
                                    app.formdata[kk].fields[z].value = value.fields[i].value;
                                }
                            }
                        }


                    }
                }
            },
           validateGroup(index){
                let app = this;
                var valid = true;

                app.formdata[index].haserror = false;
                app.formdata[index].hascontent = false;

                for (let i = 0; i < app.formdata[index].fields.length; i++) {

                    var field =  app.formdata[index].fields[i];


                    if(field.value!='')
                    {
                         app.formdata[index].hascontent = true;
                    }

                    if(field.validation.includes('required') && field.value=='')
                    {
                        valid = false;
                        app.formdata[index].fields[i].isvalid = false;
                        app.formdata[index].haserror = true;
                    }else{
                        app.formdata[index].fields[i].isvalid = true
                    }

                    if(field.validation.includes('requiredIf')){

                        for (let d = 0; d < field.validationDependency.length; d++) {
                            var value = app.getFieldValueByIndex(field.validationDependency[d]);
                            if(value != '' && field.value=='') {
                                valid = false;
                                app.formdata[index].fields[i].isvalid = false;
                                app.formdata[index].haserror = true;
                            }else{
                                app.formdata[index].fields[i].isvalid = true
                            }
                        }
                    }

                    if(field.validation.includes('requiredIfNot')){

                        for (let d = 0; d < field.validationDependency.length; d++) {
                            var value = app.getFieldValueByIndex(field.validationDependency[d]);
                            if( (value != '' && value !== false) || field.value != "") {
                                 app.formdata[index].fields[i].isvalid = true
                            }else{

                                valid = false;
                                app.formdata[index].fields[i].isvalid = false;
                                 app.formdata[index].haserror = true;
                            }
                        }
                    }


                }
                app.formdata[index].isvalid = valid;

                // const validGroups =  app.formdata.filter(item => item.isvalid  );

                var validGroups = [];
                for (const [key, value] of Object.entries(app.formdata)) {
                    if(value.isvalid)
                    {
                        validGroups.push(value);
                    }
                }

                if(validGroups.length ==  Object.keys(app.formdata).length){
                    app.formcompleted = true;
                }else{
                     app.formcompleted = false;
                }


           },
           getFieldValueByIndex(index){
                let app = this;
                var value = '';
                for (let i = 0; i < app.formdata.length; i++) {
                    for (let x = 0; x < app.formdata[i].fields.length; x++) {
                        if(app.formdata[i].fields[x].id == index)
                        {
                            value = app.formdata[i].fields[x].value;
                        }
                    }
                }
                return value;
           },
           checkCondition(cond = false){

               if(cond){

                    var ret = true;
                    let v = this.getFieldValueByIndex(cond[0]);
                    if( v && v != ''){
                       ret = true
                    }
                    else
                    {
                        ret = false
                    }

                    if(cond[1])
                    {
                        return ret;
                    }
                    else
                    {
                         return ret === false;
                    }

               }
               else
               {
                   return true;
               }
           },

            send(event){
                let app = this;
                app.loading = false;
                app.showerrors = false;


                console.log(app.formdata);

                for (const [key, value] of Object.entries(app.formdata)) {
                  app.validateGroup(key);
                }

                if(!app.formcompleted)
                {
                    app.showerrors = true;
                    event.preventDefault();
                }
                else
                {
                    localStorage.setItem('formdata', JSON.stringify(app.formdata));
                    event.preventDefault();
                    app.loading = true;
                    app.showerrors = false;

                    axios({
                        method: 'post',
                        url: '/api/sendapplication/'+app.location+"/"+app.sector.id +"/" + app.lang+"/" + app.session ,
                        data: app.formdata
                    }).then(response => {
                        if(response.data == "send" )
                            app.formHasBeenSended = true;
                            app.loading = false;
                        })
                        .catch(e => {
                            app.loading = false;
                            alert(e);

                        });

                }



            }

        }

    }
</script>
